import { Link } from 'react-router-dom';
import { ContactType } from 'constants/contacts';
import { Contact } from 'types/domain';

interface NameTableCellProps {
    contact?: Contact;
    accountId: number;
}

const NameTableCell = ({ contact, accountId }: NameTableCellProps) => {
    const { name_display, type, company_name, id } = contact ?? {};

    if (!id) {
        return <NameNotAvailable />;
    }

    const resource = type === ContactType.Individual ? 'contacts' : 'companies';
    const name = type === ContactType.Individual && name_display ? name_display : company_name;

    return (
        <Link
            className={'font-medium text-gray-900'}
            to={`/accounts/${accountId}/${resource}/${id}`}
        >
            {name ? <span>{name}</span> : <NameNotAvailable />}
        </Link>
    );
};

const NameNotAvailable = () => <span className="italic">Not available</span>;

export { NameTableCell };
